import React from 'react';
import './LuckyDrawButton.scss';

/**
 * 抽籤按鈕元件
 * 顯示在左側鞭炮旁邊
 */
const LuckyDrawButton = ({ onClick }) => {
  return (
    <button 
      className="lucky-draw-button"
      onClick={onClick}
      aria-label="抽籤祈福"
      title="點擊抽籤祈福"
    >
      <div className="button-content">
        <span className="text">點我抽籤</span>
      </div>
    </button>
  );
};

export default LuckyDrawButton;
